import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Base } from '../../../primitives/Skeleton/components/Base.js';
export const Circle = /*#__PURE__*/_styled(Base, process.env.NODE_ENV === "production" ? {
  target: "epqfaue0"
} : {
  target: "epqfaue0",
  label: "Circle"
})(process.env.NODE_ENV === "production" ? {
  name: "18wgrk7",
  styles: "border-radius:50%"
} : {
  name: "18wgrk7",
  styles: "border-radius:50%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNpcmNsZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFbUMiLCJmaWxlIjoiQ2lyY2xlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQmFzZSB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvU2tlbGV0b24vY29tcG9uZW50cy9CYXNlLmpzJztcbmV4cG9ydCBjb25zdCBDaXJjbGUgPSBzdHlsZWQoQmFzZSkgYFxuICBib3JkZXItcmFkaXVzOiA1MCU7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2lyY2xlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});